import React from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import swal from "sweetalert";
import { getCookie } from "../../inc/cookies";
import config from "../../inc/config";

import { Editor } from "react-draft-wysiwyg";
import { convertToRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";

class AuctionAddModule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,

      title: '',
      description: '',
      provider: '',
      contract: '',
      startDate: '',
      endDate: ''
    };
    this.onEditorStateChange = this.onEditorStateChange.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {}

  saveAuctionOnClick = (event) => {
    let sessionHash = getCookie('sessionHash');

    this.setState({isLoading: true});

    const startDateIso = new Date(this.state.startDate).toISOString();
    const endDateIso = new Date(this.state.endDate).toISOString();

    const requestOptions = {
      method: 'POST',
      headers: {'Authorization': 'Bearer ' + sessionHash, 'Content-Type': 'application/json'},
      body: JSON.stringify({title: this.state.title, description: this.state.description, provider: this.state.provider, contract: this.state.contract, startDate: startDateIso, endDate: endDateIso})
    };

    fetch(config.restApi + 'auction/tr', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({isLoading: false});
          swal({
            dangerMode: true,
            icon: 'success',
            title: 'Tamamlandı',
            text: 'İhale başarıyla eklendi.',
            buttons: 'Tamam'
          }).then(() => this.props.navigate('/auctions'));
        }
        break;
        default: {
          this.setState({isLoading: false});

          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

    onEditorStateChange(editor) {
      let convertContent = draftToHtml(convertToRaw(editor.getCurrentContent()))
      this.setState({contract: convertContent})
    }


  render() {
    return this.state.isLoading ? (
      <div className="ibox-content sk-loading position-static">
        <div className="sk-spinner sk-spinner-fading-circle">
          <div className="sk-circle1 sk-circle"></div>
          <div className="sk-circle2 sk-circle"></div>
          <div className="sk-circle3 sk-circle"></div>
          <div className="sk-circle4 sk-circle"></div>
          <div className="sk-circle5 sk-circle"></div>
          <div className="sk-circle6 sk-circle"></div>
          <div className="sk-circle7 sk-circle"></div>
          <div className="sk-circle8 sk-circle"></div>
          <div className="sk-circle9 sk-circle"></div>
          <div className="sk-circle10 sk-circle"></div>
          <div className="sk-circle11 sk-circle"></div>
          <div className="sk-circle12 sk-circle"></div>
        </div>
      </div>
    ) : (
      <div className="row custom-container">
        <div className="col">
          <div className="ibox">
            <div className="ibox-title d-flex justify-content-between text-darkblue pr-2">
              <h4 className="text-darkblue">İhale Ekle</h4>
              <button className="btn bg-orange text-white" onClick={this.saveAuctionOnClick} title="Kaydet"><i className="fa fa-save"></i></button>
            </div>
            <div className="row">
              <div className="col">
                <div className="ibox">
                  <div className="ibox-content text-darkblue">
                    <div className="row">
                      <div className="col">
                      <div className="row">
                        <div className="col-md-6">
                          <h5><strong>Başlık<strong className="text-danger ml-1">*</strong></strong></h5>
                          <input className="form-control form-control-sm form-input mb-1" onChange={event => this.setState({title: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Başlık" type="text" value={this.state.title} />
                        </div>
                        <div className="col-md-6">
                          <h5><strong>Açıklama<strong className="text-danger ml-1">*</strong></strong></h5>
                          <input className="form-control form-control-sm form-input mb-1" onChange={event => this.setState({description: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Açıklama" type="text" value={this.state.description} />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <h5><strong>Sağlayıcı<strong className="text-danger ml-1">*</strong></strong></h5>
                          <input className="form-control form-input mb-1" onChange={event => this.setState({provider: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Sağlayıcı" type="text" value={this.state.provider} />
                        </div>
                        <div className="col-12">
                          <h5><strong>Sözleşme<strong className="text-danger ml-1">*</strong></strong></h5>
                          <Editor
                            editorClassName= "editor-class"
                            onEditorStateChange={this.onEditorStateChange}
                            editorStyle={{border: '1px solid #F1F1F1', height: '25vh'}}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <h5><strong>Başlangıç Tarihi<strong className="text-danger ml-1">*</strong></strong></h5>
                          <input className="form-control form-inputt mb-2 mt-1" onChange={event => this.setState({startDate: event.target.value})} onKeyDown={this.handleKeyPress} type="datetime-local" value={this.state.startDate}/>
                        </div>
                        <div className="col-md-6">
                          <h5><strong>Bitiş Tarihi<strong className="text-danger ml-1">*</strong></strong></h5>
                          <input className="form-control form-inputt mb-2 mt-1" onChange={event => this.setState({endDate: event.target.value})} onKeyDown={this.handleKeyPress} type="datetime-local" value={this.state.endDate}/>
                        </div>
                      </div>
                      </div>
                    </div>
                    <div className="text-row text-right mt-2">
                      <button className="btn bg-orange text-white" onClick={this.saveAuctionOnClick}><i className="fa fa-save"></i> Kaydet</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default function AuctionAdd(props) {
  return (
    <AuctionAddModule navigate={useNavigate()} searchParams={useSearchParams()[0]}></AuctionAddModule>
  );
}
